module.exports = __webpack_public_path__ + "img/emp1-1.ec429c2a.jpg";